<template>
  <div class="home rflex">
    <left-menu></left-menu>
    <div class="menu_right wflex el-scrollbar" ref="menu_right" :style="{left:sidebar.width+'px'}">
      <head-nav></head-nav>
      <div class="menu_content" ref="menu_content">
        <!-- 导航条  -->
        <bread></bread>
        <router-view></router-view><!--页面渲染入口-->
      </div>
      <backTop :ele="$refs.menu_right"></backTop>
      <footerNav></footerNav>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'

  import HeadNav from '../components/layout/headNav.vue';
  import LeftMenu from '../components/layout/leftMenu.vue';
  import Bread from '../components/layout/bread.vue';
  import backTop from '../components/backTop';
  import footerNav from '../components/layout/footerNav';
  import * as simpleApi from "request/simple";

  export default {
    name: 'home',
    data(){
      return {
      }
    },
    computed:{
      ...mapGetters('user', ['sidebar']),
      ...mapState({
        userInfo: state => state.user.userInfo,
      }),
    },
    components:{
      HeadNav,
      LeftMenu,
      Bread, footerNav,
      backTop
    },
    created() {
    },
    mounted (){
      window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeUnmount() {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    watch:{

    },
    methods:{
      handleBeforeUnload(event) {
        console.log("cxh:",this.userInfo.token);

        // 在此处执行相应的逻辑
        event.preventDefault(); // 可选：防止浏览器显示默认的关闭提示消息
        event.returnValue = ''; // 可选：设置返回值为空字符串以兼容某些浏览器

        // simpleApi.post({controllerName: 'admin', methodName: '/teacherLogout', param: { token: this.userInfo.token }}).then(({data, code}) =>  {
        //   this.setUserInfo(null);
        // });
      }
    }
  }
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
  .home{
    .menu_right{
      overflow: auto;
      position: absolute;
      right:0;
      top:0;
      bottom:0;
      background:#F6F7FC;
      .menu_content{
        position: relative;
        margin-top:60px;
        width:100%;
        background:#f0f2f5;
      }

    }
  }
</style>
